import { ExclamationTriangleIcon } from "@heroicons/react/24/outline"
import classNames from "classnames"

export default function InputGroup(props) {

    const { children, className, error } = props

    return (
        <div className={classNames('input-group', className, {
            'error': error
        })}>
            { children }
            { error &&
                <span className="error-message flex items-center gap-1">
                    <ExclamationTriangleIcon className="w-[1.125rem]" />
                    { error.type === 'required'
                        ? '此為必填欄位'
                        : error.message
                    }
                </span>
            }
        </div>
    )
}